<template>
  <div>
    <PageHeader icon="i_user" :title="$t('addUser')" :breadcrumbs="[
      { name: $t('menu_users'), route: '/users' },
      { name: $t('addUser'), route: '' },
    ]">
    </PageHeader>

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <form action="" id="editProfile" @submit.prevent="submitForm">

                <h5>{{ $t("generalDetails") }}</h5>

                <br>

                <!-- איש צוות: a crew member already on the list (picking one fills the details
                     below) or a new one from the details - linked after the user is created -->
                <div class="row" v-if="isUserManager">
                  <div class="col-md-6">
                    <UserCrewMemberField ref="crewMember"
                                         :formUser="userToAdd"
                                         @pick="onCrewMemberSelected"></UserCrewMemberField>
                  </div>
                </div>

                <div class="row" v-if="$store.state.user.type == 1 && userToAdd.type == 5">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">*{{ $t("bizCategory") }}</label>
                      <select class="form-control" v-model="userToAdd.bizCategory">
                        <option v-for="(category) in this.bizCategories" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- the modules the account opens with, ticked by the category (GET root-admin/features):
                     a venue gets every module but the catalog, any other business the everyday set -->
                <div class="row" v-if="$store.state.user.type == 1 && userToAdd.type == 5">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">*{{ $t("bizServices") }}</label>
                      <ul class="newAccountModules" style="list-style:none;padding:0;margin:0;">
                        <li v-for="feature in features" :key="feature.key" class="newAccountModule" :data-key="feature.key" style="padding:4px 0;">
                          <label style="user-select:none;cursor:pointer" :title="feature.description"
                                 @click="toggleModule(feature.key)">
                            <span style="position:relative;top:1px;"
                                  class="planup-checkbox planup-checkbox-purple"
                                  :class="{ checked: userToAdd.modules.includes(feature.key) }">
                              <i class="fa fa-check"></i>
                            </span>
                            <i :class="feature.icon" style="width:18px;text-align:center;color:#868686;"></i>
                            {{ feature.name }}
                          </label>
                        </li>
                      </ul>
                      <small style="color:#868686;display:block;margin-top:6px;">
                        מסומנים לפי סוג העסק: אולם מקבל את כל המודולים חוץ מקטלוג / מלאי. אפשר לשנות גם אחרי הפתיחה, בכרטיס החשבון.
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">*{{ $t("fullName") }}</label>
                      <input class="form-control" type="text" maxlength="50" v-model="userToAdd.name" required />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">{{ $t("phone") }}
                        <span style="color:#868686;font-weight:400;">({{ $t("mobile") }})</span>
                      </label>
                      <input class="form-control" type="tel" v-model="userToAdd.phone" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">*{{ $t("email") }}</label>
                      <input class="form-control" type="email" v-model="userToAdd.email" required />
                    </div>
                  </div>

                  <div class="col-md-4" v-if="userToAdd.type != 5">
                    <div class="mb-3">
                      <label class="form-label">{{ $t("role") }}</label>
                      <input class="form-control" type="text" v-model="userToAdd.attrs.roleName" />
                    </div>
                  </div>
                </div>

                <div v-if="userToAdd.type != 5">

                  <div v-if="isUserManager" style="margin-bottom:12px;">

                    <h5 style="margin-top:10px;">הרשאות</h5>

                    <!-- עמדת אירוח (biz-services 11): the reception-desk login. Exclusive — when it is
                         on, every other privilege is moot: the user sees the station and nothing else. -->
                    <div v-if="hostingStationEnabled">
                      <label style="user-select:none;cursor:pointer;display:block;margin-top:10px;"
                             @click="userToAdd.isHostingStation = !userToAdd.isHostingStation">
                        <span style="position:relative;top:1px;"
                              class="planup-checkbox planup-checkbox-purple"
                              :class="{ checked: userToAdd.isHostingStation }">
                          <i class="fa fa-check"></i>
                        </span>
                        משתמש עמדת אירוח
                      </label>
                      <small style="color:#868686;display:block;margin-bottom:8px;">
                        הכניסה של עמדת הקבלה בכניסה לאולם: בוחרים זוג, מחפשים אורחים ומסמנים הגעה. המשתמש רואה רק את מסך העמדה - בלי יומן, לקוחות או הגדרות.
                      </small>
                    </div>

                    <div v-if="!userToAdd.isHostingStation">

                    <label style="user-select:none;cursor:pointer;display:block;margin-top:10px;"
                           @click="userToAdd.isAdmin = !userToAdd.isAdmin">
                      <span style="position:relative;top:1px;"
                            class="planup-checkbox planup-checkbox-purple"
                            :class="{ checked: userToAdd.isAdmin }">
                        <i class="fa fa-check"></i>
                      </span>
                      משתמש מנהל
                    </label>
                    <small style="color:#868686;display:block;margin-bottom:8px;">
                      הרשאות מלאות כמו בעל העסק: רואה הכל, עורך הכל, ויכול בעצמו להוסיף ולנהל משתמשים.
                    </small>

                    <div v-if="!userToAdd.isAdmin">

                      <label style="user-select:none;cursor:pointer;display:block;"
                             @click="userToAdd.viewAllEvents = !userToAdd.viewAllEvents">
                        <span style="position:relative;top:1px;"
                              class="planup-checkbox planup-checkbox-purple"
                              :class="{ checked: userToAdd.viewAllEvents }">
                          <i class="fa fa-check"></i>
                        </span>
                        רואה את כל האירועים
                      </label>
                      <small style="color:#868686;display:block;margin-bottom:8px;">
                        ללא סימון — יראה ויערוך רק אירועים שהוא משויך אליהם (כאיש צוות, יוצר או אחראי).
                      </small>

                      <label style="user-select:none;cursor:pointer;display:block;"
                             @click="userToAdd.viewAllMeetings = !userToAdd.viewAllMeetings">
                        <span style="position:relative;top:1px;"
                              class="planup-checkbox planup-checkbox-purple"
                              :class="{ checked: userToAdd.viewAllMeetings }">
                          <i class="fa fa-check"></i>
                        </span>
                        רואה את כל הפגישות
                      </label>
                      <small style="color:#868686;display:block;margin-bottom:8px;">
                        ללא סימון — יראה ויערוך רק פגישות שהוא משויך אליהן.
                      </small>

                      <label style="user-select:none;cursor:pointer;display:block;"
                             @click="userToAdd.seeFinancials = !userToAdd.seeFinancials">
                        <span style="position:relative;top:1px;"
                              class="planup-checkbox planup-checkbox-purple"
                              :class="{ checked: userToAdd.seeFinancials }">
                          <i class="fa fa-check"></i>
                        </span>
                        גישה לנתונים כספיים
                      </label>
                      <small style="color:#868686;display:block;margin-bottom:8px;">
                        כולל הצעות מחיר, חשבוניות, מסמכי מס, הוצאות ודוחות. ללא סימון — הנתונים הכספיים מוסתרים מהמשתמש.
                      </small>

                      <label style="user-select:none;cursor:pointer;display:block;"
                             @click="userToAdd.seeSettings = !userToAdd.seeSettings">
                        <span style="position:relative;top:1px;"
                              class="planup-checkbox planup-checkbox-purple"
                              :class="{ checked: userToAdd.seeSettings }">
                          <i class="fa fa-check"></i>
                        </span>
                        גישה להגדרות העסק
                      </label>
                      <small style="color:#868686;display:block;margin-bottom:8px;">
                        צפייה ועריכה של הגדרות הארגון, מסמכים, פרמטרים ותבניות.
                      </small>

                    </div>

                    <!-- Experimental module — orthogonal to "משתמש מנהל", so it stays visible and
                         applies even when the admin toggle is on. Shown only when the logged-in
                         manager holds the key (root-admin grants it to the account). -->
                    <div v-if="canManageInventory">
                      <label style="user-select:none;cursor:pointer;display:block;margin-top:4px;"
                             @click="userToAdd.seeInventory = !userToAdd.seeInventory">
                        <span style="position:relative;top:1px;"
                              class="planup-checkbox planup-checkbox-purple"
                              :class="{ checked: userToAdd.seeInventory }">
                          <i class="fa fa-check"></i>
                        </span>
                        קטלוג (ניסיוני)
                      </label>
                      <small style="color:#868686;display:block;margin-bottom:8px;">
                        מודול חדש בהרצה לניהול קטלוג פריטים, השכרות ומכירות. מוצג רק למשתמשים שסומנו.
                      </small>
                    </div>

                    </div><!-- /!isHostingStation -->

                  </div>

                  <div class="row" v-if="this.$store.state.user.type == 1">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label class="form-label">*{{ $t("app_domain") }}</label>
                        <input class="form-control" type="text" maxlength="50" v-model="userToAdd.app.domain" required />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label class="form-label">*{{ $t("app_name") }}</label>
                        <input class="form-control" type="text" maxlength="50" v-model="userToAdd.app.name" required />
                      </div>
                    </div>
                  </div>
                </div>

                <br>
                <br>

                <h5>{{ $t("passwordUpdate") }}</h5>

                <br>

                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">*{{ $t("password") }}</label>
                      <password :badge="false" :secureLength="6" :required="true" :placeholder="null" v-model="userToAdd.password"></password>
                    </div>
                  </div>
                </div>

                <button type="submit" class="btn btn-primary pull-right">{{ $t("save") }}</button>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Password from "vue-password-strength-meter";
import PageHeader from "../Common/PageHeader.vue";
import ROLES_ENUM from "../../core/auth/roles.enum.js";
import UserCrewMemberField from "./UserCrewMemberField.vue";
import { hasService, HOSTING_STATION_SERVICE_ID } from "@/core/acl/venue";

export default {
  name: "AddUser",
  watch: {
      // picking a category starts the module list over from that kind of business's defaults
      "userToAdd.bizCategory"() {
        this.applyDefaultModules();
      }
  },
  data() {
    return {
      userToAdd: {
        type: this.$store.state.user.type == ROLES_ENUM.Admin ? ROLES_ENUM.HallManager : ROLES_ENUM.HallManagerChild,
        name: "",
        phone: "",
        email: "",
        modules: [],           // a new business account's modules (root admin) - the server derives bizServices
        attrs: { roleName: "" },
        app: {} ,
        // Privilege toggles — composed into permission keys by the create endpoint.
        isAdmin: false,        // full HallManager-equivalent privileges (admin marker)
        viewAllEvents: false,  // events.viewAll — otherwise only events they're tagged in
        viewAllMeetings: false,// meetings.viewAll — otherwise only meetings they're tagged in
        seeFinancials: false,  // financial bundle (quotations, billing, tax docs, expenses, reports)
        seeSettings: false,    // settings.view — business settings pages
        seeInventory: false,   // 'inventory' — experimental Inventory & Rentals module
        isHostingStation: false, // עמדת אירוח — the reception-desk login (exclusive marker)
      },
      bizCategories: null,
      features: null,
    };
  },
  computed: {
    // Business owner (type 5) or an admin child (type 6 holding users.create via the admin marker).
    isUserManager() {
      const u = this.$store.state.user;
      if (!u) return false;
      if (u.type === ROLES_ENUM.HallManager) return true;
      return u.type === ROLES_ENUM.HallManagerChild
        && u.permissions != null
        && Object.keys(u.permissions).includes('users.create');
    },
    // The inventory module is root-admin-controlled: only a manager who was granted the key
    // themselves may pass it to a new user, so the toggle is hidden otherwise (backend enforces too).
    canManageInventory() {
      const u = this.$store.state.user;
      return !!u && u.permissions != null && Object.keys(u.permissions).includes('inventory');
    },
    // The reception-desk user exists only for accounts the system admin gave עמדת אירוח (service 11)
    hostingStationEnabled() {
      return hasService(this.$store.state.user, HOSTING_STATION_SERVICE_ID);
    },
  },
  components: {
    Password,
    PageHeader,
    UserCrewMemberField
  },
  mounted() { },

  beforeMount() {


    this.$store
      .dispatch("restGet", { 'route': 'biz-categories' })
      .then((response) => {
        this.bizCategories = response;
      })


    if (this.$store.state.user.type == ROLES_ENUM.Admin)
      this.$store
        .dispatch("restGet", { 'route': 'root-admin/features' })
        .then((response) => {
          this.features = response;
          this.applyDefaultModules();
        })


   },
  methods: {
    onCrewMemberSelected(crewMember) {
      if (!crewMember) return;
      // Pull the linked crew member's details into the new-user form
      this.userToAdd.name = crewMember.name || "";
      this.userToAdd.phone = crewMember.phone || "";
      this.userToAdd.email = crewMember.email || "";
    },
    // a venue is a category that carries biz-service 9 (אולם - האם לאירוע מוצמד אולם)
    isVenueCategory(categoryId) {
      const category = (this.bizCategories || []).find(x => x.id == categoryId);
      return !!category && (category.services || []).map(Number).indexOf(9) > -1;
    },
    applyDefaultModules() {
      if (!this.features) return;
      const venue = this.isVenueCategory(this.userToAdd.bizCategory);
      this.userToAdd.modules = this.features.filter(f => venue ? f.venueDefaultOn : f.defaultOn).map(f => f.key);
    },
    toggleModule(key) {
      let index = this.userToAdd.modules.indexOf(key);
      if (index > -1) {
        this.userToAdd.modules.splice(index, 1);
      } else {
        this.userToAdd.modules.push(key);
      }
    },
    roles() {
      return { ריסלר: ROLES_ENUM.Resseler, ספק: ROLES_ENUM.HallManager };
    },
    submitForm() {
      const userType = this.$store.state.user.type;
      if (userType == ROLES_ENUM.Admin) {
        this.createResselerUser();
      } else if (userType == ROLES_ENUM.HallManager || userType == ROLES_ENUM.HallManagerChild) {
        // Admin children (users.create) create users exactly like the owner does.
        this.createNormalUser();
      }
    },

    createResselerUser() {
      if (
        typeof this.$data.userToAdd.password !== "undefined" &&
        this.$data.userToAdd.password.length < 6
      ) {
        this.AlertError(this.$t("passwordLength"));
        return false;
      }
      this.$store
        .dispatch("restPost", {
          route: "users/resseler",
          data: this.$data.userToAdd,
        })
        .then((response) => {
          this.AlertSuccess(this.$t("userAdded"))
          // .then((user) => {
          //   this.$router.push("/users/");
          // });
        })
        .catch((response) => {
          this.AlertError();
          console.error(response)
        });
    },
    createNormalUser() {
      this.$store
        .dispatch("addUser", this.$data.userToAdd)
        .then((response) => {
          // איש צוות: link the new user 1:1 to a crew member, or make one from its details
          // (build spec §3.2)
          const newUserId = response && response.user ? response.user.id : null;
          if (newUserId && this.$refs.crewMember) {
            return this.$refs.crewMember.apply(newUserId)
              .catch((e) => { console.warn("crew link failed", e); });
          }
        })
        .then(() => {
          this.$swal({
            confirmButtonText: this.$t("okButton"),
            type: "success",
            title: this.$t("userAdded"),
            timer: 2000,
          })
            .then((user) => {
              this.$router.push("/users/");
            })
            .catch(this.$swal.noop);
        })
        .catch((response) => {
          this.AlertError();
          console.error(response)
        });
    },
  },
};
</script>
